import * as styles from '../../styles/components/UserDashboards.less';
import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { withTranslation, WithTranslation } from "react-i18next";
import Loader from '../common/Loader';
import { DASHBOARD_URL } from '../../constants/config';
import { useAppSelector } from '../../store/hooks';
import { EntityId } from '../../types/models';

interface UserDashboardsOwnProps {
  filterCustomers: EntityId[];
  className?: string;
  isLoading?: boolean;
}

const UserDashboards = (props: UserDashboardsOwnProps & WithTranslation) => {
  const { t } = props; // [t, i18n]
  const navigate = useNavigate();
  const dashboards = useAppSelector((store) => store.customer.dashboards);
  const [showDisabledDashboards, setShowDisabledDashboards] = useState(false);

  // Render all dashboards not disabled at the 1st time rendered.
  // - ticking 'Show disabled dashboards' rendered all.
  // - if filtering customers list is set, display only listed customers' dashboards.
  const renderDashboards = () => dashboards.map((dashboard, i) => (
    <div key={i} style={{display: 'flex'}}>
      <div className={((!dashboard.disabled || showDisabledDashboards) &&
                       (!props.filterCustomers.length || (dashboard.customerId !== undefined && props.filterCustomers.indexOf(dashboard.customerId) > -1))) ? props.className : 'hidden'}>
        <button style={{visibility: 'hidden', background: 'white', marginRight: '0.5rem'}}
          key={i}
          onClick={() => navigate('/dashboard/' + dashboard._id)}>
          <i className="fa fa-users" aria-hidden="true" style={{opacity: 0.5}}></i>
        </button>
        <Link
          className={styles.dashboard}
          style={{float: 'left', color: dashboard.disabled ? 'grey' : 'green'}}
          to={`/dashboard/${dashboard._id}`}
          >{dashboard.name}
        </Link>
        <a style={{float:'left', marginLeft:'0.2rem', opacity: dashboard.disabled ? '0.5' : '1', color: dashboard.disabled ? 'grey' : 'green'}}
          // Update cache when opening dashboard
          href={`${DASHBOARD_URL}?hash=${dashboard._id}&cache=del`}
          title="Open dashboard"
          target="_blank"><i className="fa fa-external-link" aria-hidden="true"></i>
        </a>
      </div>
    </div>
  ));

  // Boolean toggle tickbox handler
  const handleShowDisabledCheckBox = (_event: React.ChangeEvent<HTMLInputElement>) => {
    setShowDisabledDashboards((prev) => !prev);
  };

  return (
    <div>
      <label>
        <input
          type="checkbox"
          onChange={handleShowDisabledCheckBox}
        />
        {t('dashboard.showDisabled')}
      </label>
      {props.isLoading && <Loader />}
      <div style={{height:"0.4em"}}></div>
      {renderDashboards()}
    </div>
  );
};

export default withTranslation('common')(UserDashboards);
